import { normalizeSearchString } from '../../utils/normalizeSearchString';
import {
  COMPANY_FIRST_STEP_FIELD_TYPES,
  COMPANY_SECOND_STEP_FIELD_TYPES,
  COMPANY_FOURTH_STEP_FIELD_TYPES,
} from './constants';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import env from '../../env';
import { AppClientId } from './../Shared/constants';

dayjs.extend(customParseFormat);

export function parseCompany(company) {
  for (let i = 0; i < company.properties.length; i++) {
    const prop = company.properties[i];
    if (prop?.name?.name === 'id') continue;
    let value = prop.value;
    if (['account_manager_user_id'].includes(prop.name.name)) {
      try {
        value = JSON.parse(value);
      } catch (e) {}
    }
    if (['used_credit_limit_details'].includes(prop.name.name)) {
      try {
        value = JSON.parse(value);
      } catch (e) {}
    }
    company[prop.name.name] = value;
  }
  company.label = company.name ?? company.name;
  company.__search =
    company.company_type === 'company'
      ? normalizeSearchString(company.name)
      : normalizeSearchString(`${company.name} ${company?.surname}`);
  company.__email_search = normalizeSearchString(company.email);
  return company;
}

export const parseStoreCompany = function(company, index) {
  let props = {};
  let properties = [];
  for (let i = 0; i < company.properties?.length; ++i) {
    if (company.properties[i]?.name?.name === 'id') continue;
    if (!['address', 'company'].includes(company.properties[i].name.name)) {
      let value = company.properties[i].value;
      if (['account_manager_user_id'].includes(company.properties[i].name.name)) {
        try {
          value = JSON.parse(value);
        } catch (e) {}
      }
      if (['used_credit_limit_details'].includes(company.properties[i].name.name)) {
        try {
          value = JSON.parse(value);
        } catch (e) {}
      }
      props[company.properties[i].name.name] = value;
      properties.push(company.properties[i]);
    }
  }
  props.parentCompany = !!company?.parentCompanies?.length ? company?.parentCompanies[0] : {};
  if (props?.parentCompany) {
    props.parentCompany.name = props.parentCompany?.properties?.find(p => p?.name?.name === 'name')?.value;
  }
  company.label = company.name ?? company.name;

  return { ...company, ...props, properties };
};

export const resetCompanyProperties = function(step) {
  if (!step) {
    return;
  }
  if (step === 1) {
    return COMPANY_FIRST_STEP_FIELD_TYPES;
  } else if (step === 2) {
    return COMPANY_SECOND_STEP_FIELD_TYPES;
  } else if (step === 3) {
    return [];
  } else if (step === 4) {
    return COMPANY_FOURTH_STEP_FIELD_TYPES;
  }
};

export const getStringWithoutSymbols = function(string) {
  let withoutSymbols = string.replace(/!|@|#|$|%|^|&|±|_/g, '');

  return normalizeSearchString(withoutSymbols);
};

export const getDaysBetweenDates = function(oldDate, newDate) {
  const date1 = new Date(oldDate);
  const date2 = new Date(newDate);

  // To calculate the time difference of two dates
  const differenceInTime = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);

  return differenceInDays;
};

export const formatedDateNow = function() {
  const date = dayjs(new Date(Date.now()))?.format('DD-MM-YYYY');

  return date;
};

export const isShowViesCheck = function(companyType, companyFrom) {
  if (env.clientId === AppClientId.AUTOWIENTJES && companyFrom?.toLowerCase() === 'nl') return false;
  if (companyType == 'individual' || companyFrom?.toLowerCase() === 'outside_eu') return false;

  return true;
};

export const parseAddressToCompanyValues = function(address, countries = []) {
  const countryId = countries?.find(c => c.name?.toLowerCase() === address?.country?.toLowerCase())?.id;

  let companyAddress = {
    name: address?.name,
    addressLine1: address?.street || address?.streetnumber ? `${address?.street || ''} ${address?.streetnumber || ''}` : '',
    postcode: address?.postalcode,
    city: address?.city,

    website: address?.website,
    phone_number: address?.phonenumber,
    lat: address?.lat,
    lng: address?.lng,
  };

  if (countryId) {
    companyAddress.countryId = countryId;
  }

  return companyAddress;
};

export const compareAdresses = function(address1, address2) {
  const isNotEqual = JSON.stringify(address1) !== JSON.stringify(address2);
  return isNotEqual;
};

export const switchCountryCodeInput = function(input) {
  requestAnimationFrame(() => {
    if (input.current) {
      input.current.focus();

      const length = input.current.value.length;
      input.current.setSelectionRange(length, length);
    }
  });
};
